    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            menus: null,
            menuState: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        menus: state => {
            return state.menus
        },
        menuState: state => {
            return state.menuState
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        menus: (state, payload) => {
            state.menus = payload
        },
        menuState: (state, payload) => {
            state.menuState = payload
        },
    }

    const actions = {
       
        getMenus: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/menus')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('menus', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postMenu ({commit, dispatch}, payload) {
            commit('menuState', null)
            commit('updating', true)
            axiosAuth.post('/menus', payload)
                .then(
                    res => {
                        console.log(res)
                        commit('trash', res)
                        commit('updating', false)
                        commit('menuState', true)
                        dispatch('getMenus')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                    commit('menuState', false)
                }
                )
        },

        updateMenu: ({commit}, payload) => {        
            console.log('update menu')    
            commit('updating', true)
            axiosAuth.patch('/menus/'+ payload._id, payload.data)
            .then(
                res => {

                    commit('trash', res)
                    commit('updating', false)
                    // dispatch('getMenus')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteMenu: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/menus/'+ payload._id)
            .then(
                () => {
                    dispatch('getMenus')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }